module.exports = __webpack_public_path__ + "static/img/S116_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S116_1.png
// module id = yFvx
// module chunks = 0